import { useEffect, useState } from 'react';
import { CacheProvider } from '@emotion/react';
import Link from '@mui/material/Link';
import { appendStyleSheet, getEndpoint, getID, getMUICache, getUrl, getImageSize, getImageUrl, convertEpochTime, GetFallBackImage, isImageSizeBlank, getImageId, fetchAnchorValue } from '../../../common/utils';
import { I_CDSListingItemTO } from '@interfaces/ICDSListingResponseTO';
import "./HomeGridViewThree.css";
import Grid from '@mui/material/Grid';
import DescriptionIcon from '@mui/icons-material/Description';
import bcrypt from 'bcryptjs-react';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';

HomeGridViewThree.version = 1000;

HomeGridViewThree.lang = 'en';
HomeGridViewThree.langs = [
  'en'
];
HomeGridViewThree.setLang = (lang: any) => {
  HomeGridViewThree.lang = lang;
}

Object.defineProperty(HomeGridViewThree, 'name', {
  writable: true,
  value: 'HomeGridViewThree'
});

export function HomeGridViewThree(props: any) {
  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();

  useEffect(()=>{
    EagerLoadImages()
},[]);

  let styles = require("./HomeGridViewThree.css");
  const [msid, setMsid] = useState<any>('');
  const [items, setItems] = useState<I_CDSListingItemTO[]>([]);
  appendStyleSheet("HomeGridViewThree", styles);
  const endpoint = getEndpoint(props);
  const { showAuthor, showDate, mainHeadingColor, mainHeadingHref, mainHeading, viewAllText, tagColor, tagTextColor, anchorLinksValue } = props
  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj) {
      fetchComponentData();
    }
  }, [props.MSID, endpoint, props.showAdSlot]);

  const setItemsObj = (response: any) => {
    setItems(response?.items)
  }

  if (endpoint.isSSR && endpoint.SSRDataObj && (!items || !items.length)
    && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length != 0) {
    setItemsObj(endpoint.SSRDataObj);
  }

  const fetchComponentData = () => {
    getData(getUrl(props));
  }

  const getData = (url: string) => {
    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = { 'p-nonce': headerString };

    fetch(url, { headers: headers })
      .then((response) => response.json())
      .then(response => {
        setItemsObj(response);
      })
      .catch(err => {
        //console.log(err);
      });
  }

  const getRenderPart = () => {
    if (msid && props.msid && msid != props.msid) {
      props.queryParams.msid = props.msid;
      setMsid(props.queryParams.msid);
      getData(getUrl(props));
    }

    if (!items || !items.length) {
      return "";
    }

    let componentID = getID(props.data);

    return <CacheProvider value={getMUICache()}>
      <div id={componentID}>
        <div className='commoncontainer'>
          <div className='ThemeThreeHomeGridViewHeadingWrap ThemeThreeHeadingMainWrapper'>
            <p className='ThemeThreeCommonSubHeading'>NEWS UPDATE</p>
            <p className='ThemeThreeWHomeGridViewHeading themeThreeCommonComponentsHeading'><a href={mainHeadingHref} target={fetchAnchorValue(anchorLinksValue, mainHeadingHref)} style={{ color: mainHeadingColor }}>{mainHeading}</a></p>
          </div>
          <Grid className='ThemeThreeHomeGrid'>
            {items &&
              items.map((itemObj, index) => {
                return <Link href={itemObj.wu} key={'2_' + index} target={fetchAnchorValue(anchorLinksValue, itemObj.wu)} className='ThemeThreeWebHomeGridViewCardWrapSlide'>

                  <div className='ThemeThreeWebHomeGridViewCardWrap' style={{ backgroundColor: props.cardBgColor }}>
                    <div className='ThemeThreeWebHomeGridViewCardImgWrap'>

                      {isImageSizeBlank(itemObj.imageid) ? <picture>
                        <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 366, 206, "", false, props.CONSTANTS, '8')} />
                        <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 280, 158, "", false, props.CONSTANTS, '8')} />
                        <img alt={itemObj?.hl?.slice(0, 25) ?? ''} title={itemObj?.hl?.slice(0, 25) ?? ''} loading="lazy" />

                      </picture> : <img src={GetFallBackImage()} alt={itemObj?.hl?.slice(0, 25) ?? ''} title={itemObj?.hl?.slice(0, 25) ?? ''} loading="lazy"/>}
                      <div className='ThemeThreeImageTag'>
                        <p className='ThemeThreeImageTagName' style={{ backgroundColor: tagColor, color: tagTextColor }} >{itemObj?.cat}</p>
                      </div>
                    </div>
                    <div className='ThemeThreeImageBottomContentWrap'>
                      {showDate && <div className='themeThreedateAgencyWrap themeThreeHomeGridDateAgencyWrap'>
                        <p className='ThemeThreeCommonAuthorWrapper'><DescriptionIcon />{convertEpochTime(itemObj.lpt, 'updated', "DD MMM YYYY")}</p>
                      </div>}
                      <div className='ThemeThreeWebHomeGridViewCarContentWrap'>
                        <p className='ThemeThreeHomeGridViewDiscription' style={{ color: props.cardTextColor }}>{itemObj.hl}</p>
                      </div>
                      <div className='themeThreedateAgencyWrap themeThreeHomeGridDateAgencyWrap'>
                        {showAuthor && <p className='themeThreeHeroLayoutDateTimeAgency '><span className='manageAuthorName'>{itemObj.au}</span></p>}
                      </div>
                    </div>

                  </div>


                </Link>
              }
              )}

          </Grid>
        </div>
        <div className='themeThreeViewAll'><Link href={mainHeadingHref} target={fetchAnchorValue(anchorLinksValue, mainHeadingHref)} >{viewAllText}</Link></div>
      </div>
    </CacheProvider>
  }


  return (
    <>
      {getRenderPart()}
    </>
  );

}














